module.exports = __webpack_public_path__ + "components/country-flag/static/sl-7bb5c467efa0d3bfa5488e0d9f4cfe0d.svg";